import Constant from '@/const';
import axios from 'axios';

const putStatusGoods = async payload => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/goods/activation`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putStatusGoods;
